import { useInView } from '@shared/Frontend/hooks/useInView'
import React from 'react'
import { cn } from '@shared/Frontend/utils/addToClassName'
import { Breadcrumbs } from '../breadcrumbs'
import { PageheaderActions } from './pageheaderActions'
import { PageheaderImage } from './pageheaderImage'
import { PageHeaderProps } from './types'

export const PageheaderNZO = ({
  title,
  introduction,
  primaryAction,
  secondaryAction,
  image,
  breadcrumbs,
  extraClasses,
  kind,
}: PageHeaderProps) => {
  const { inView, ref } = useInView({ threshold: 0.1 })
  const isHome = kind == 'home'
  const isNews = kind == 'news'
  return (
    <>
      {breadcrumbs && !isHome && <Breadcrumbs breadcrumbs={breadcrumbs} />}

      <header ref={ref} className={cn(`pageheader ph ph--${image ? 'image' : 'text'}`, isHome && 'ph--home', isNews && 'ph--news', inView && 'inview', extraClasses)}>
        <div className='ph__outer'>
          <div className="ph__inner ls-container ls-gutter gridsys--columns">
            <div className="ph__text">
              {title && <h1 className={cn('ph__title', isHome ? 'title--2xl' : 'title--xl')}>{title}</h1>}

              {introduction &&
                <p className="ph__intro text--xl">{introduction}</p>
              }

              <PageheaderActions primaryAction={primaryAction} secondaryAction={secondaryAction} isHome={isHome} />
            </div>

            <PageheaderImage image={image} isHome={isHome} />
          </div>
        </div>

        {!isHome && (
          <svg className="ph__shape" width="1920" height="140" viewBox="0 0 1920 140" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1899.66 0C1764.07 2.58767 1595.95 50.8679 1396.48 81.1846C1125.23 122.416 704.1 158.194 477.8 111.713C317.7 78.8765 135.58 41.1254 0 40.1445V140H1920V0H1899.66Z" fill="#fff"/></svg>
        )}
      </header>
    </>
  )
}
